import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import NavigationButton from "components/NavigationButton/NavigationButton.js";
import PromptLabHubComponent from "components/PromptLabHub/PromptLabHubComponent.js";
import { getLessonMetaByRoute, getNextLessonRoute } from "pages/claudeCourse/lessonsRegistry.js";

const ROUTE = "CC_M1_L15";
const BACK = "CC_M1_L14";

const CC_M1_L15Component = ({ setAiPageContext, setCurrentCode, setCurrentOuput }) => {
    const meta = getLessonMetaByRoute(ROUTE);
    const nextRoute = getNextLessonRoute(ROUTE);
    const [allCompleted, setAllCompleted] = useState(false);
    useEffect(() => { setAiPageContext?.("claudeCourseLesson"); }, [setAiPageContext]);
    return (
        <div className="lessonBackgroundColor1 lessonMain" style={{ minHeight: "100vh" }}>
            <LessonNavBar />
            <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
                <section>
                    <PromptLabHubComponent lessonMeta={meta} setallCheckboxesCompleted={setAllCompleted} setCurrentCode={setCurrentCode} setCurrentOuput={setCurrentOuput} />
                </section>
                <section>
                    <Container className="container-lg">
                        <Row className="p-3 align-items-center justify-content-between">
                            <NavigationButton direction="back" page={BACK} />
                            {allCompleted && nextRoute && <NavigationButton direction="next" page={nextRoute} />}
                        </Row>
                    </Container>
                </section>
            </main>
        </div>
    );
};

export default CC_M1_L15Component;
